import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {NavigationEnd, Router, RouterLink,} from '@angular/router';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {Meta, Title} from '@angular/platform-browser';
import {SettingsService} from '../../services/settings.service';
import {SettingsComponent} from '../../components/settings/settings.component';


@Component({
  selector: 'billets-page',
  templateUrl: './billets.component.html',
  imports: [
    NgForOf,
    RouterLink,
    SettingsComponent
  ],
  styleUrl: './billets.component.less'
})
export class BilletsPageComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router,  private title: Title, private meta: Meta, public BilletsService:BilletsService, public SettingsService: SettingsService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });

  }
  ngOnInit(): void {
    this.title.setTitle('Билеты ПДД 2026 🚗: по номеру, экзамен ГИБДД, тест, марафон | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Выберите формат подготовки: билеты ПДД по номеру, тестовый экзамен, экзамен как в ГИБДД или марафон из 800 вопросов. Бесплатно, онлайн, с пояснениями к ответам.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'билеты пдд 2026, экзамен гибдд онлайн, тестовый экзамен пдд, марафон пдд, билеты пдд по номерам, решить билет пдд, сдать пдд онлайн'
    });
  }

}
